import React from 'react'
import { useNavigate } from 'react-router-dom';

const CartItem = ({ item, onRemoveItem }) => {
    const navigate = useNavigate()
    return (
        <div className="cart-item d-flex align-items-start gap-2 justify-content-between mb-4" onClick={() => navigate(`/product-detail/${item?.product?.id}`)} style={{ cursor: 'pointer' }}>
            <div className='cart-left d-flex align-items-center gap-2'>
                <div className='product-card-image'>
                    <img src={item?.logos[0]?.previewUrl || item?.image} alt={""} />
                </div>
                <div className='card-content'>
                    <h3 className='mb-1'>{item?.name}</h3>
                    <p className='mb-1'>Qty: {item?.quantity} | Size: {item?.size}</p>
                    <h3 className='link-text mb-0'>${item?.price?.toFixed(2)}</h3>
                </div>
            </div>
            <div className='cancel-card' onClick={(e) => { e.stopPropagation(); onRemoveItem(item?.id) }} style={{ cursor: 'pointer' }}>
                <img src="/image/close.svg" alt="Remove item" />
            </div>
        </div>
    )
}

export default CartItem